import React from "react";
import CoreSignalStrength from "./CoreSignalStrength";
import "./Top25.scss";
import ReactTooltip from "react-tooltip";

export default function Top25(props) {
  const [signal, setSignal] = React.useState("TRADE_RANGE_ODDS");
  const [handler, setHandler] = React.useState("");

  //Detecting screen size change
  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  React.useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  return (
    <div>
      <div className="dashboard-content" style={{ padding: 0 }}>
        <div className="top-25-top-section">
          <div className="columnTop25" id="top25">
            {/* Top 25 header */}
            <div className="top-label">
              <p>
                Top 25 Buy/Cover and Top 25 Sell/Short security tickers and
                their respective Longbow Trading Ranges ranked by Core Signal
                Strength on our securities universe updated once per day at the
                close.
              </p>
            </div>
            <div
              className="cross-asset-class-volatility"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className="buttons"
                style={
                  window.matchMedia("(max-width: 480px)").matches
                    ? { display: "block" }
                    : null
                }
              >
                {/* `button 1D ${
                    // period === "1D" || period === "Daily" ? "selected" : ""
                  }` */}
                <div
                  onClick={() => {
                    setSignal("LONGBOW_SIGNAL_STRENGTH");
                  }}
                  className={`button 1D`}
                  style={{
                    width: "auto",
                    padding: 15,
                    backgroundColor:
                      signal === "LONGBOW_SIGNAL_STRENGTH" ? "#666666" : "",
                  }}
                >
                  Core Signal Strength
                </div>
                <div
                  onClick={() => {
                    setSignal("TRADE_RANGE_ODDS");
                  }}
                  className={`button 1D`}
                  style={{
                    width: "auto",
                    padding: 15,
                    backgroundColor:
                      signal === "TRADE_RANGE_ODDS" ? "#666666" : "",
                  }}
                >
                  Trade Range Odds
                </div>
                <div
                  onClick={() => {
                    setSignal("CURR_IMP_VOL_DISC_PREM");
                  }}
                  className={`button 1D`}
                  style={{
                    width: "auto",
                    padding: 15,
                    backgroundColor:
                      signal === "CURR_IMP_VOL_DISC_PREM" ? "#666666" : "",
                  }}
                >
                  Volatility Premium/Discount
                </div>
                <ReactTooltip place="top" />
              </div>
            </div>
            {/* Top 25 tables */}
            <CoreSignalStrength reload={props.reload} signal={signal} />
          </div>
        </div>
      </div>
    </div>
  );
}
